import {Component, Inject, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ConfService} from '../../../conf.service';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-add-api-gateway-new',
  templateUrl: './add-api-gateway-new.component.html',
  styleUrls: ['./add-api-gateway-new.component.scss']
})
export class AddApiGatewayNewComponent implements OnInit {


  gatewayTypes = [
    {
      type: 'kong',
      display_name: 'Kong'
    },
    {
      type: 'aws',
      display_name: 'AWS API Gateway'
    },
    {
      type: 'azure',
      display_name: 'Azure API Management Service'
    }
  ];
  selectedGateway = 'kong';
  isEdit = false;

  returnWithoutCreate = false;
  disableGatewayNameInput = false;
  disableGatewayTypeSelector = false;
  gatewayName = '';

  inputData: any;

  partner: any;
  account: any;
  partnerKey: any;

  loading = false;

  passphrase = environment.cipheringPhrase;

  iterationCount = 1000;
  keySize = 128 / 32;

  showAccessKeyOnPress = false;
  showSecretKeyOnPress = false;

  constructor( private confPost: ConfService,
               public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef<AddApiGatewayNewComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }

  isValidUrl(url: string): boolean {
  const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*$/;
  return urlPattern.test(url);
  }
  
  isValidPort(port: string): boolean {    
    const isValid = /^\d+$/.test(port) && +port >= 0 && +port <= 65535;
    return isValid;
  }

  isValidHost(host: string): boolean {
    const hostPattern = /^(?:(?!-)[A-Za-z0-9-]{1,63}(?<!-)\.?)+([A-Za-z]{2,}|(?:\d{1,3}\.){3}\d{1,3}|localhost)$/;
    return hostPattern.test(host);
  }

  isValidProtocol(protocol: string): boolean {
    const protocolPattern = /^(https?|ftp|ftps)?$/;
    return protocolPattern.test(protocol);
  }

  

  async ngOnInit() {
    this.changeGateway('aws');
    this.partner = this.data.partner;
    this.account = this.data.account;
    this.partnerKey = this.data.partnerKey;

    if (this.data.isEdit) {
      this.isEdit = true;
    }
    if (this.data.disableGatewayNameInput) {
      this.disableGatewayNameInput = true;
    }
    if (this.data.disableGatewayTypeSelector) {
      this.disableGatewayTypeSelector = true;
    }
    if (this.data.gatewayType) {
      this.selectedGateway = this.data.gatewayType;
      this.changeGateway(this.selectedGateway);
    }
    if (this.data.returnWithoutCreate) {
      this.returnWithoutCreate = this.data.returnWithoutCreate;
    }

    if (this.data.apigateway) {
      if (this.data.apigateway.type) {
        this.changeGateway(this.data.apigateway.type);
        if (this.data.apigateway.type.toLowerCase() === 'aws') {
          this.inputData.name = this.data.apigateway.name;
          this.inputData.type = this.data.apigateway.type;

          if (this.data.apigateway.shash && this.data.apigateway.ralam) {
            if (this.data.apigateway.config) {
              if (this.data.apigateway.config.accessKey) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.accessKey, this.keySize, this.iterationCount).then(response => {
                  this.inputData.accessKey = response;
                });
              }
              if (this.data.apigateway.config.secretKey) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.secretKey, this.keySize, this.iterationCount).then(response => {
                  this.inputData.secretKey = response;
                });
              }
              if (this.data.apigateway.config.region) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.region, this.keySize, this.iterationCount).then(response => {
                  this.inputData.region = response;
                });
              }
            }
          } else {
            this.inputData.accessKey = this.data.apigateway.accessKey;
            this.inputData.secretKey = this.data.apigateway.secretKey;
            this.inputData.region = this.data.apigateway.region;
          }

        } else if (this.data.apigateway.type.toLowerCase() === 'azure') {
          this.inputData.name = this.data.apigateway.name;
          this.inputData.type = this.data.apigateway.type;

          if (this.data.apigateway.shash && this.data.apigateway.ralam) {
            if (this.data.apigateway.config) {
              if (this.data.apigateway.config.subscriptionId) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.subscriptionId, this.keySize, this.iterationCount).then(response => {
                  this.inputData.subscriptionId = response;
                });
              }
              if (this.data.apigateway.config.resourceGroupName) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.resourceGroupName, this.keySize, this.iterationCount).then(response => {
                  this.inputData.resourceGroupName = response;
                });
              }
              if (this.data.apigateway.config.serviceName) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.serviceName, this.keySize, this.iterationCount).then(response => {
                  this.inputData.serviceName = response;
                });
              }
              if (this.data.apigateway.config.tenant_id) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.tenant_id, this.keySize, this.iterationCount).then(response => {
                  this.inputData.tenant_id = response;
                });
              }
              if (this.data.apigateway.config.client_id) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.client_id, this.keySize, this.iterationCount).then(response => {
                  this.inputData.client_id = response;
                });
              }
              if (this.data.apigateway.config.client_secret) {
                await this.platform.decryptAttribute(this.data.apigateway['shash'], this.data.apigateway['ralam'], this.passphrase, this.data.apigateway.config.client_secret, this.keySize, this.iterationCount).then(response => {
                  this.inputData.client_secret = response;
                });
              }
            }
          } else {
            this.inputData.subscriptionId = this.data.apigateway.subscriptionId;
            this.inputData.resourceGroupName = this.data.apigateway.resourceGroupName;
            this.inputData.serviceName = this.data.apigateway.serviceName;
            this.inputData.tenant_id = this.data.apigateway.tenant_id;
            this.inputData.client_id = this.data.apigateway.client_id;
            this.inputData.client_secret = this.data.apigateway.client_secret;
          }
        } else if (this.data.apigateway.type.toLowerCase() === 'kong') {
          this.inputData.name = this.data.apigateway.name;
          this.inputData.type = this.data.apigateway.type;
          if (this.data.apigateway.config) {
            this.inputData.host = this.data.apigateway.config.host;
            this.inputData.port = this.data.apigateway.config.port;
            this.inputData.protocol = this.data.apigateway.config.protocol;
          }
          if (this.data.apigateway.url) {
            this.inputData.url = this.data.apigateway.url;
          }
        }
      }
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addGateway() {

    if (this.returnWithoutCreate) {
      this.dialogRef.close(this.inputData);
    } else {
      this.loading = true;
      this.confPost.manageApiGateways(this.partner, this.account, this.partnerKey, this.isEdit ? 'update' : 'create',
          this.inputData).toPromise().then(response => {
        this.platform.openSnackBar('API Gateway ' + (this.isEdit ? 'updated' : 'added') + ' successfully', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.loading = false;
        this.dialogRef.close(true);
      }, error => {
        this.loading = false;
        this.platform.handleErrorGracefully(error, 'Error while adding API gateway');
      });
    }
  }

  changeGateway(e) {
    this.selectedGateway = e;
    if (e === 'kong') {
      this.inputData = {
        'name': '',
        'type': 'kong',
        'provider': 'apiplatform.io',
        'gateway_configurations': [],
        'url': [
          ''
        ],
        'protocol': '',
        'host': '',
        'port': null,
        'primary_region': 'US-East (N.Virginia)'
      };
    } else if (e === 'azure') {
      this.inputData = {
        name: '',
        type: 'azure',
        subscriptionId: '',
        resourceGroupName: '',
        serviceName: '',
        tenant_id: '',
        client_id: '',
        client_secret: ''
      };
    } else {
      this.inputData = {
        name: '',
        type: 'aws',
        accessKey: '',
        secretKey: '',
        region: ''
      };
    }
  }
}
